/*eslint-disable*/

// Ajax search results

$('#loadMoreSearch').click(function(e) {
  e.preventDefault();
  var $container = $('.search__ajax_results');

  jQuery.ajax({
    type       : "GET",
    data       : { 
      page: pageNumber,
      query: searchQuery,
      dataType   : "jsonp",
      action:'ajax_search', 
    },
    url: '../../wp-admin/admin-ajax.php',
    success    : function(data){
      pageNumber++;
      if(data.length) {
        data = JSON.parse(data);
        var content = data;

        $(content).hide().appendTo($container).fadeIn(300);

        if (pageNumber >= totalPages) {
         $('#loadMoreSearch').remove();
        }
      }
    },
  });
});


// WEBPACK FOOTER //
// ./scripts/routes/search.js